import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { WxrlRulesListComponent } from './pages/wxrl-rules-list/wxrl-rules-list.component';
import { WxrlRuleDetailComponent } from './pages/wxrl-rule-detail/wxrl-rule-detail.component';
import { WxrlConditionsListComponent } from './components/wxrl-conditions-list/wxrl-conditions-list.component';

import { WxrlRuleTriggersComponent } from './components/wxrl-rule-triggers/wxrl-rule-triggers.component';
import { WxrlRuleActionsComponent } from './components/wxrl-rule-actions/wxrl-rule-actions.component';
import { SNCheckPipe } from './pipes/sncheck.pipe';
import { InheritedPipe } from './pipes/inherited.pipe';
import { WxrlRuleListFiltersComponent } from './components/wxrl-rule-list-filters/wxrl-rule-list-filters.component';
import { WxrlRuleLogsComponent } from './components/wxrl-rule-logs/wxrl-rule-logs.component';
import { WxrlRuleLogsFiltersComponent } from './components/wxrl-rule-logs-filters/wxrl-rule-logs-filters.component';
import { BooleanIndicatorComponent } from './components/boolean-indicator/boolean-indicator.component';
import { HighlightPipe } from './pipes/highlight.pipe';
import { WxrlSummaryComponent } from './components/wxrl-summary/wxrl-summary.component';
import { WxrlSchemaComponent } from './components/wxrl-schema/wxrl-schema.component';
import { WxrlFormHeaderComponent } from './components/wxrl-form-header/wxrl-form-header.component';
import { WxrlConditionDrawerComponent } from './components/wxrl-condition-drawer/wxrl-condition-drawer.component';
import { WxrlActionDrawerComponent } from './components/wxrl-action-drawer/wxrl-action-drawer.component';
import { WxrlTriggerDrawerComponent } from './components/wxrl-trigger-drawer/wxrl-trigger-drawer.component';
import { WxrlHeaderDrawerComponent } from './components/wxrl-header-drawer/wxrl-header-drawer.component';
import { WxrlFormulaEditorComponent } from './components/wxrl-formula-editor/wxrl-formula-editor.component';
import { WxrlAuthorsComponent } from './components/wxrl-authors/wxrl-authors.component';
import { WxrlFormulaDrawerComponent } from './components/wxrl-formula-drawer/wxrl-formula-drawer.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SidebarModule } from 'primeng/sidebar';
import { TreeTableModule } from 'primeng/treetable';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { InputNumberModule } from 'primeng/inputnumber';
import { ProgressBarModule } from 'primeng/progressbar';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [
    WxrlRulesListComponent,
    WxrlRuleDetailComponent,
    WxrlConditionsListComponent,
    WxrlRuleTriggersComponent,
    WxrlRuleActionsComponent,
    SNCheckPipe,
    InheritedPipe,
    WxrlRuleListFiltersComponent,
    WxrlRuleLogsComponent,
    WxrlRuleLogsFiltersComponent,
    BooleanIndicatorComponent,
    HighlightPipe,
    WxrlSummaryComponent,
    WxrlSchemaComponent,
    WxrlFormHeaderComponent,
    WxrlConditionDrawerComponent,
    WxrlActionDrawerComponent,
    WxrlTriggerDrawerComponent,
    WxrlHeaderDrawerComponent,
    WxrlFormulaEditorComponent,
    WxrlAuthorsComponent,
    WxrlFormulaDrawerComponent,
  ],
  imports: [
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    ConfirmDialogModule,
    SidebarModule,
    TreeTableModule,
    InputTextareaModule,
    ContextMenuModule,
    DialogModule,
    TableModule,
    InputNumberModule,
    ProgressBarModule,
    TooltipModule,
  ],
})
export class WXRLModule {}
